import React from 'react';
import { connect } from 'react-redux';
import IconLabel from 'material-ui/svg-icons/action/label';
import './styles.css';

const MenuItem = props => {
  const { menuKey, navElemType, activeKey, dispatch } = props;
  const linkStyle = {
    fontSize: '12px',
    cursor: 'pointer',
    padding: '5px',
    textAlign: 'center',
    color: '#fff'
  }
  const linkContainerStyle = {
    marginTop: '3px',
    marginLeft: '5px',
    width: '160px',
    border: '1px solid #ddd',
    borderRadius: '10px',
    position: 'relative',
    color: 'rgba(0, 0, 0, 0.75)'
  }
  const iconLabelStyle = {
    position: 'absolute',
    fill: 'rgb(242, 242, 242)',
    stroke: '#ddd',
    left: '-24px'
  }
  const iconDivStyle = {
    position: 'absolute',
    left: '-8px',
    width: '1px',
    height: '12px',
    background: 'rgb(242, 242, 242)',
    top: '6px',
    zIndex: '9999'
  }
  return (
    <div
      className='categoryNavLinkContainer'
      style={linkContainerStyle}
      id={menuKey}
      onClick={
        (e) => {
          const el = document.getElementById(menuKey);
          var rect = el.getBoundingClientRect(),
          scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const right = rect.right - 160;
          const top = rect.top + scrollTop;
          dispatch({
            type: 'SET_CATEGORY',
            p: menuKey.split('.')[1]
          });
          dispatch({
            type: 'SET_CATEGORY_MENU_ITEM_ACTIVE_KEY',
            payload: menuKey
          });
          dispatch({
              type: 'SET_CATEGORY_MENU_ITEM_POS',
              payload: { right, top }
          });
          dispatch({
            type: 'SET_SCREEN',
            name: 'categoryData',
            val: true
          });
        }
      }
    >
      {menuKey === activeKey && <IconLabel style={iconLabelStyle} /> }
      {menuKey === activeKey && <div style={iconDivStyle}></div> }
      <div className='categoryNavLinkDescr' style={linkStyle}>{navElemType}</div>
    </div>
  );
}

export default connect(
  state => ({ activeKey: state.ui.categoryMenuItemActiveKey })
)(MenuItem);



// WEBPACK FOOTER //
// ./src/components/layout/content/catalog/category/menu-item.js